// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieBar_container__7GdAK","text":"CookieBar_text__2QyaJ","signup":"CookieBar_signup__1DBDK","cookieText":"CookieBar_cookieText__165UL"};